export enum PeriodoFiltroDashboard {
  DIAS_30 = 30,
  DIAS_60 = 60,
  DIAS_90 = 90,
}
